import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Demo tenant constants (must match backend pkg/auth/tenant.go)
export const DEMO_TENANT_ID = 'demo-tenant-001'
export const DEMO_TENANT_NAME = 'Demo Restaurant'

interface Tenant {
  tenantId: string
  businessName: string
  industry: string
}

interface User {
  userId: string
  email: string
  tenants: Tenant[]  // User can belong to multiple tenants
}

interface AuthState {
  user: User | null
  token: string | null
  activeTenant: Tenant | null
  isAuthenticated: boolean
  isDemo: boolean
  
  // Actions
  setUser: (user: User, token: string, activeTenant?: Tenant) => void
  setActiveTenant: (tenant: Tenant) => void
  logout: () => void
  enterDemoMode: () => void
}

// Default demo tenant for unauthenticated users
const demoTenant: Tenant = {
  tenantId: DEMO_TENANT_ID,
  businessName: DEMO_TENANT_NAME,
  industry: 'restaurant',
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      activeTenant: demoTenant,  // Default to demo tenant
      isAuthenticated: false,
      isDemo: true,  // Default to demo mode
      
      setUser: (user, token, activeTenant) =>
        set({
          user,
          token,
          activeTenant: activeTenant || user.tenants[0] || demoTenant,
          isAuthenticated: true,
          isDemo: false,
        }),
      
      setActiveTenant: (tenant) =>
        set({ activeTenant: tenant }),
      
      logout: () =>
        set({
          user: null,
          token: null,
          activeTenant: demoTenant,
          isAuthenticated: false,
          isDemo: true,
        }),
      
      enterDemoMode: () =>
        set({
          user: null,
          token: null,
          activeTenant: demoTenant,
          isAuthenticated: false,
          isDemo: true,
        }),
    }),
    {
      name: 'autoledger-auth',
    }
  )
)
